<script lang="ts">
  import Carousel from 'svelte-carousel';
  import { Image } from 'sveltestrap';
  import data from '../../../Data/BonusUi/BonusUi.json';
  import { BasicExample } from '../../../utils/Constant/Constant';
  import Card from '../../Core/Card.svelte';
  let imgPath:String = "/assets/images"
  let carousel:any;
  let y:number ,x:number, z:number
  const handlecarousel = (value:number) =>{
    if(value <= 425){
        x = 1
    }else{
      if(value <= 1440){
         x = 3
      }else{
          x = 5
      }
    }
    return x
  }
  const handlescroll = (value:number) => {
    if(value <= 425){
       z = 1
    }else{
      if(value <= 1440){
        z = 2
      }else{
         z = 4
      }
    }
    return z
  }
</script>
<svelte:window bind:innerWidth={y}/>
<Card headerTitle={BasicExample} cardHeaderprops="pb-0">
  <div slot="contentbody" id="owl-carousel-1">
    <Carousel bind:this={carousel} particlesToShow={handlecarousel(y)} arrows={false} particlesToScroll={handlescroll(y)}>
      {#each data.src as item}
        <div class="item" style="margin-right: 10px;">
          <Image fluid src="{imgPath}/{item.img}"  alt="" />
        </div>
      {/each}
    </Carousel>
  </div>
</Card>
